import React from "react";

// React DOM
import { useNavigate, useParams } from "react-router-dom";

// Components
import BookTable from "./BookTable";
import BookForm from "./BookForm";

const Book = (props) => {
  const {
    isLoading,
    setLoading,
    books,
    fetchAllBooks,
    setShowAlertWorkshop,
    setWorkshopAlertMsg,
  } = props;
  const { crud } = useParams();
  const navigate = useNavigate();
  const { editId } = useParams();

  if (crud) {
    return (
      <BookForm
        navigate={navigate}
        setShowAlertWorkshop={setShowAlertWorkshop}
        setWorkshopAlertMsg={setWorkshopAlertMsg}
        fetchAllBooks={fetchAllBooks}
        editId={editId}
      />
    );
  } else {
    return (
      <BookTable
        navigate={navigate}
        isLoading={isLoading}
        fetchAllBooks={fetchAllBooks}
        setLoading={setLoading}
        books={books}
      />
    );
  }
};

export default Book;
